var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "stroke",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1559 16.9919V18.4319C15.1559 19.6248 14.1888 20.5919 12.9959 20.5919H5.75985C4.56692 20.5919 3.59985 19.6248 3.59985 18.4319V5.75985C3.59985 4.56692 4.56692 3.59985 5.75985 3.59985H12.9959C14.1888 3.59985 15.1559 4.56692 15.1559 5.75985V7.19985",
    strokeWidth: 1.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4118 12.1318H10.6558",
    stroke: "#1B1B1B",
    strokeWidth: 1.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6631 14.5079L20.2754 12.8955C20.6972 12.4738 20.6972 11.79 20.2754 11.3682L18.6631 9.75586",
    strokeWidth: 1.728,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 19.2,
    fill: "white",
    transform: "translate(2.3999 2.3999)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.606436d693cb8ca3e93c730304343a05.svg";
export { ForwardRef as ReactComponent };